<div [ngClass]="position()" class="tooltip" [style.maxWidth]="maxWidth()" [style.display]="'none'">
  <div class="content">{{ text() }}</div>
  @if (arrow() !== false) {
    <ui-inline-svg
    class="arrow"
    [class]="position()"
    name="tooltip-arrow-bottom"></ui-inline-svg>
  }
</div>
